module.exports = __webpack_public_path__ + "static/img/one.6aa7953.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gRDImg/one.png
// module id = PRZM
// module chunks = 1